import React, { Component, Fragment } from 'react';
import { FaDog } from 'react-icons/fa';


export class SmartLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: this.props.size ?? '20px'
        };
    }

    render() {
        return (
            <Fragment>
                <span style={{ cursor: 'pointer', fontSize: this.state.size }} onClick={this.props.onClick}>
                    <FaDog height={this.state.size} /> {this.props.text}{'    '}
                </span>
            </Fragment>
        );
    }
}